/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-types */
 import { Component, ElementRef, Inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AppService } from '../../api.service';
import { Meta, Title } from '@angular/platform-browser';
import { OwlService } from '../../services/owl.service';
import { Location, ViewportScroller, isPlatformBrowser } from '@angular/common';
import { fadeimagesInOut } from '../../animations';
import { ConnectService } from '../../services/connect.service';
import { ShareService } from '../../services/share.service';
import { LocalStorageService } from '../../services/localstorage.service';

@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.scss'],
  animations:[fadeimagesInOut]
})
export class DetailComponent implements OnInit{
  global_loader = true;
  brand_info: any;
  mostViewProductList: any[]=[];
  sub_category_list: any[] = [];
  activesubcategory_id = 0;
  subCateName: any;
  show_location_popup = false;
  total_product: any;
  total_num_of_product_pages: any;
  product_list: any;
  brandslug: any;
  ppage_number: any = 1;
  dpage_number: any = 1;
  sppage_number: any = 1;
  dealers_list: any[] = [];
  totalDealer: any;
  total_num_of_pages: any;
  maintabs: any;
  city_list: any[] = [];
  city_name: any;
  citytypes: any[] = [];
  citys_id: any;
  productSection = true;
  dealerSection = false;
  is_product_loading = false;
  main_category: any;
  @ViewChild('product') productView!:ElementRef;
  @ViewChild('dealer') dealerView!:ElementRef;
  @ViewChild('company') companyView!:ElementRef;
  show_about_company = false;
  page_load = false;
  category_list_string!: string;
  is_mostviewd=false;
  catId!:number;
  constructor(@Inject(PLATFORM_ID) private platformId: Object,private _ar:ActivatedRoute, public _as:AppService,private _router: Router,public title: Title,private meta:Meta,public _location:Location,
    public _owlOption:OwlService,private ViewportScroller:ViewportScroller,public _connect:ConnectService,public _share:ShareService,private localStorageService: LocalStorageService){}


  ngOnInit(): void {
   
    this._ar.queryParams.subscribe((pra:any) => {
      this.activesubcategory_id = pra.catId
    });
    this._ar.params.subscribe((params:any) => {
      this.brandslug = params['brandSlugName'];
      
    });
    if(isPlatformBrowser(this.platformId)){
    // this.ViewportScroller.scrollToPosition([0, 0]); 
    this.getDetailsData();
    this.getCityType();
    this.page_load = true;
  }
  }


  getDetailsData() {
    const url = this._as.api_base_url + 'oem/oemd/' + this.brandslug+'/';
    this._as.getRequest(url, true)
      .subscribe((res:any) => {
        this.brand_info = res.data;
        if(Object.keys(this.brand_info).length){
          this.show_about_company = true;
        }
        // this.mostViewProductList = res.product_list;
        this.getMostViewProducts();
        this.main_category = res.main_category;
        this.onCategoryTab(1,false);
      },
        (err:any)=>{
          console.log(err);
          this.global_loader = false;
        }
      );
  }
  
getMostViewProducts(){
  const url = this._as.api_base_url + 'oem/brand-mvp/?slug_name=' + this.brandslug;
  this._as.getRequest(url, true)
    .subscribe((res:any) => {
      this.mostViewProductList = res.product_list;
    },
      (err:any)=>{
console.log(err);
this.mostViewProductList = [];
      }
    );
  
}

  setseoValue() {

    this.title.setTitle(this.brand_info.name + ' | afterbricks');
    this.meta.addTags([
      {
        name: 'keywords',
        content: this.category_list_string,
      },
      { name: 'robots', content: 'index, follow' },
      { charset: 'UTF-8' },
    ]);
    let img_link :string;
    if(this.brand_info?.cover_pic){
      img_link = this.brand_info?.cover_pic;
    }else{
      img_link = this.brand_info?.logo;
    }
    this.meta.updateTag({property: 'og:title', content:this.brand_info.name + ' | afterbricks'});
  this.meta.updateTag({property: 'og:image', content: img_link});
  this.meta.updateTag({property: 'og:url', content:  this._as.site_url+this._router.url})
  this.meta.updateTag({name: 'description',content:this.brand_info.name + ' product offering from '+ this.category_list_string+' etc.'})  
  }

  getSubcategory() {
    const url = this._as.api_base_url + 'oem/oscategory/?slug_name=' + this.brandslug;
    this._as.getRequest(url, true)
      .subscribe((res:any) => {
        this.global_loader = false;
        if (res.sub_category_list.length) {
          this.sub_category_list = res.sub_category_list;
          if(this.activesubcategory_id){
            this.onSubcat(this.activesubcategory_id);
          }
          else{
            this.onSubcat(this.sub_category_list[0].id);
          }
        }

      });
      this.setseoValue();
  }


  onSubcat(subcatid:any) {
    this.activesubcategory_id = subcatid;
    let url: string;
    if (!subcatid) {
      this.subCateName = "Products"
      url = this._as.api_base_url + 'oem/opl/?slug_name=' + this.brandslug + '&page=' + this.ppage_number;
    }
    else {
      const subindex = this.sub_category_list.findIndex(scl => scl.id == subcatid);
      this.subCateName = this.sub_category_list[subindex].name;
      url = this._as.api_base_url + 'oem/opl/?slug_name=' + this.brandslug + '&sub_cat=' + subcatid + '&page=' + this.sppage_number;
    }
    this.is_product_loading=true;
    this._as.getRequest(url, true)
      .subscribe((res:any) => {

        this.total_product = res.total_found_product;
        this.total_num_of_product_pages = res.page;
        this.product_list = res.data;
        this.is_product_loading=false;
       
      }, (err:any) => {
        if(err){
          this.is_product_loading=false;
        }
      });
  }

  onDealerDetail() {
    // this.global_loader = true;
    const url = this._as.api_base_url + 'oem/oemdlrlist/?slug_name=' + this.brandslug + '&page=' + this.dpage_number;
    this._as.getRequest(url, true)
      .subscribe((res:any) => {
        if(this.citytypes.length){
          this.show_location_popup = true;
        }
        this.show_location_popup = true;
        this.dealerSection = true;
        this.productSection = false;
        this.global_loader = false;
        this.dealers_list = res.dealer_list;
        this.totalDealer = res.total_found_dealer;
        this.total_num_of_pages = res.page;
        this.maintabs = 2;
      });
  }

  onCitySelect(city_name:any){
    this.global_loader = true;
    this.city_name = city_name;
    const url = this._as.api_base_url + 'oem/oemdlrlist/?slug_name=' + this.brandslug + '&page=' + this.dpage_number;
    this._as.getRequest(url, true)
      .subscribe((res:any) => {
        const dealers = res.dealer_list.filter((dealer:any)=>{
          return dealer.city === city_name;
        });
        this.dealers_list = dealers;
        this.totalDealer = dealers.length;
        this.total_num_of_pages = res.page;
        this.maintabs = 2;
        this.global_loader = false;
        setTimeout(() => {
          if (this.dealerView) {
            this.dealerView.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }, 100);
      }, (err:any) => {
        if(err)
        this.global_loader = false;
      });
  }


  getCityType() {
    const url = this._as.api_base_url + 'oem/mfgcity/?slug_name=' + this.brandslug;
    this._as.getRequest(url, true)
      .subscribe((res:any) => {
        for (const ct of res.data) {
          this.citytypes.push({ name: ct.name, id: ct.id ,icon:ct.icon});
        }
      });
  }

  valueChange(id:any, flag?:any) {
    if (flag) {
      this.citys_id = id;
    }
    else {
      this.citys_id = id.id;
    }
    const url = this._as.api_base_url + 'oem/oemdlrlist/?slug_name=' + this.brandslug + '&page=' + this.dpage_number + '&form_type=sort_by&city=' + this.citys_id;
    this._as.getRequest(url, true)
      .subscribe((res:any) => {
        this.dealers_list = res.dealer_list;
        this.totalDealer = res.total_found_dealer;
        this.total_num_of_pages = res.page;
      });
  }
  onPageChange(event:any) {
    this.dpage_number = event.page + 1;
    this.ppage_number = event.page + 1;
    this.sppage_number = event.page + 1;
    if (this.maintabs == 2) {
      if (this.citys_id) {
        this.valueChange(this.citys_id, true);
      }
    }
    else if (this.maintabs == 1) {
      this.onSubcat(this.activesubcategory_id);
    }
    this.ViewportScroller.scrollToPosition([0,0]);
  }
  onCategoryTab(tab:any,flag?:any) {
    this.show_location_popup = false;
    this.maintabs = tab;
    if (this.maintabs == 1) {
      this.productSection = true;
      this.dealerSection = false;
      this.getSubcategory();
      if(flag){
        setTimeout(() => {
          if (this.productView) {
            this.productView.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }, 100);
      }
    }
    else{
      this.productSection = false;
      this.dealerSection = false;
      setTimeout(() => {
        if (this.companyView) {
          this.companyView.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 100);
    }
  }
  onSelectDealer(){
    let paramsObject: any;
        this._ar.queryParamMap
            .subscribe((params:any) => {
                paramsObject = { ...params };
            }
            );
        const redirectTo = {
            link: this._router.url.split('?')[0],
            queryParams: paramsObject.params
        }
        this.localStorageService.setItem('redirectTo', JSON.stringify(redirectTo));
    // this._router.navigate([`dealer/` + dealerId]);
  }
  onBrand() {
    this._router.navigate(['brand'], { queryParams: { mid: this.main_category } })
  }

  onConnect(){
    if(this._as.isUserLoggedIn){
      this._connect.setFormValues();
    }
    this._connect.connect_item_image_url = this.brand_info?.logo;
    this._connect.connect_item_name = this.brand_info?.name;
    this._connect.getConnectData(this.brand_info)
  }
  onShare(){
    this._share.share_item_image_url=this.brand_info.logo;
    this._share.share_item_name=this.brand_info.name;
    this._share.share_link=this._as.site_url+this._router.url;
    this._share.displayShare=true;
  }
}
